import type { FilterOptions, DropdownOption } from "../filter-fields"
import { CheckboxFilter, MultiSelectDropdownFilter } from "../filter-fields"
import type { FilteringModalProps } from "../filtering-modal"
import { FilteringModal } from "../filtering-modal"
import type { UserAttributesDataType } from "~/utils/data"
import { UserAttributeFilterType, Countries } from "~/utils/data"

export type FilterOptionsMap = {
  [key: string]: FilterOptions
}

interface StarsFilteringModalProps extends Omit<FilteringModalProps, "filters"> {
  filters: FilterOptionsMap
  setFilter: (key: string, values: FilterOptions) => void
  completeUserAttributes: UserAttributesDataType[]
}
export const StarsFilteringModal: React.FC<StarsFilteringModalProps> = ({
  open,
  setOpen,
  title,
  filters,
  setFilter,
  onClearAll,
  onSubmit,
  completeUserAttributes,
}) => {
  const filterElements = (
    <>
      {completeUserAttributes.map(({ value, label, options, type }) => {
        if (type === UserAttributeFilterType.Checkbox) {
          return (
            <CheckboxFilter
              key={value}
              filterName={label}
              options={options}
              selectedOptions={(filters[value] as string[]) || []}
              onChange={(selected: string[]) => setFilter(value, selected)}
            />
          )
        } else if (type === UserAttributeFilterType.Dropdown && value === "location") {
          return (
            <MultiSelectDropdownFilter
              key={value}
              filterName={label}
              placeholder={`Select ${label}`}
              options={options.map((option) => ({
                value: option,
                label: Countries.find((country) => country.code === option)?.label || option,
              }))}
              selectedOptions={(filters[value] as DropdownOption[]) || []}
              onChange={(selected: DropdownOption[]) => setFilter(value, selected)}
            />
          )
        } else if (type === UserAttributeFilterType.Dropdown && value === "other") {
          return (
            <MultiSelectDropdownFilter
              key={value}
              filterName={label}
              placeholder={`Select ${label}`}
              options={options.map((option) => ({
                value: option,
                label: option,
              }))}
              selectedOptions={(filters[value] as DropdownOption[]) || []}
              onChange={(selected: DropdownOption[]) => setFilter(value, selected)}
            />
          )
        }
        return null
      })}
    </>
  )

  return (
    <FilteringModal
      open={open}
      setOpen={setOpen}
      title={title}
      filters={filterElements}
      onClearAll={onClearAll}
      onSubmit={onSubmit}
    />
  )
}
